import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initializeApp } from "firebase/app";
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAdIXkLc6V40D9JBg2h1BkRVByOrosq0WY",
  authDomain: "dietplanner-eea22.firebaseapp.com",
  projectId: "dietplanner-eea22",
  storageBucket: "dietplanner-eea22.firebasestorage.app",
  messagingSenderId: "309222244566",
  appId: "1:309222244566:web:d804f810a842b9304e0977",
  measurementId: "G-6840LTV15H"
};

// Initialize Firebase
window.appInstance  = initializeApp(firebaseConfig);
window.analytics = getAnalytics(window.appInstance);

const { default: App } = await import('./App.js'); // Dynamic import
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

